<svg
  width="22"
  height="22"
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="m8 11.167 2 2 4.5-4.5M8.202 19.768c.328-.043.659.046.92.247l1.203.923c.398.306.951.306 1.348 0l1.248-.959c.234-.179.528-.258.82-.219l1.561.206c.497.065.976-.211 1.168-.675l.601-1.453c.112-.272.328-.488.6-.6l1.453-.6c.464-.192.74-.672.675-1.169l-.198-1.505a1.24 1.24 0 0 1 .247-.92l.923-1.203a1.106 1.106 0 0 0 0-1.348l-.959-1.249a1.105 1.105 0 0 1-.219-.819l.206-1.562a1.108 1.108 0 0 0-.675-1.168l-1.453-.6a1.103 1.103 0 0 1-.6-.6l-.6-1.454a1.107 1.107 0 0 0-1.169-.675l-1.562.206a1.1 1.1 0 0 1-.817-.217l-1.25-.959a1.105 1.105 0 0 0-1.347 0l-1.249.96a1.115 1.115 0 0 1-.818.218L6.696 2.37a1.108 1.108 0 0 0-1.167.674l-.6 1.453a1.117 1.117 0 0 1-.6.6l-1.453.6c-.464.192-.74.671-.675 1.168l.206 1.562c.038.291-.041.586-.219.818l-.959 1.249a1.106 1.106 0 0 0 0 1.348l.959 1.248c.179.234.258.528.219.82L2.2 15.47c-.065.497.211.976.675 1.168l1.453.601c.272.113.488.328.6.6l.6 1.454c.192.463.672.74 1.169.674l1.504-.199Z"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
